import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Header, SubHeader } from 'shared/components/ui/Typography'
import themeVars from 'ui_theme/site/globals/site.variables'

const CenteredHeader = styled('header')`
  text-align: ${({ alignment }) => alignment || 'center'};
`

const PageHeader = ({ primary, secondary, alignment }) => {
  return (
    <CenteredHeader alignment={alignment}>
      {primary && (
        <Header
          size="medium"
          as="h1"
          fontType="display"
          css={css`
            &&& {
              font-size: ${themeVars['36px']} !important;
            }
          `}
        >
          {primary}
        </Header>
      )}
      {secondary && (
        <SubHeader
          size="tiny"
          as="h2"
          color="dark"
          css={css`
            &&& {
              margin-top: 0 !important;
            }
          `}
        >
          {secondary}
        </SubHeader>
      )}
    </CenteredHeader>
  )
}

export default PageHeader
